import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Checkbox } from 'react-toolbox';
import { requestSurfaceTypesList } from 'actionCreators';
import styles from 'styles/form';
import RTCheckbox from 'styles/checkbox.scss';
import { getSurfaceTypeList } from '../../../../reducers';
import S from './styles.scss';

class SurfaceTypesCheckbox extends React.Component {
  componentDidMount() {
    if (!this.props.loaded) {
      this.props.requestSurfaceTypesList();
    }
  }

  isChecked = st =>
    this.props.selectedSurfaceTypes.indexOf(st.id) > -1;

  renderSurfaceType = (st) => {
    const { onChange } = this.props;

    return (
      <Checkbox
        key={st.id}
        checked={this.isChecked(st)}
        label={st.name}
        theme={RTCheckbox}
        className={styles.checkboxListItem}
        onChange={val => onChange(st.id, val)}
      />
    );
  }

  render() {
    const { availableSurfaceTypes, required, error } = this.props;

    const errorStyles = `${S.error} ${S.errorText}`;
    const labelStyles = `
      ${S.label}
      ${styles.formLabel}
      ${styles.checkboxListLabel}
      ${error && S.errorText}
    `;

    return (
      <div className={styles.formElementContainer}>
        <span className={labelStyles}>Surface Types{required && ' *'}</span>
        {availableSurfaceTypes.map(st => this.renderSurfaceType(st))}
        <br className={S.clearFix} />
        {error && <span className={errorStyles}>{error}</span>}
      </div>
    );
  }
}

SurfaceTypesCheckbox.propTypes = {
  availableSurfaceTypes: PropTypes.array,
  selectedSurfaceTypes: PropTypes.array,
  loaded: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  requestSurfaceTypesList: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

SurfaceTypesCheckbox.defaultProps = {
  availableSurfaceTypes: [],
  selectedSurfaceTypes: [],
  error: '',
};

export default connect(
  state => ({
    loaded: state.surfaceTypes.loaded,
    availableSurfaceTypes: getSurfaceTypeList(state) || [],
  }),
  { requestSurfaceTypesList },
)(SurfaceTypesCheckbox);



// WEBPACK FOOTER //
// ./client/app/shared/components/formElements/SurfaceTypesCheckbox/index.jsx